// extracted by extract-css-chunks-webpack-plugin
module.exports = {"coming_soon":"ComingSoon__coming_soon--2kOkc"};